export default "__VITE_ASSET__DJ72n0az__"